export enum ObjectLostAffair {
  OBJECT_LOST = 'OBJECT_LOST',
  OTHERS = 'OTHERS'
}
